export default "__VITE_ASSET__56b52d57__"